export function formatCurrency(
  value: number,
  currencyCode: string,
  locale: string,
  options?: Intl.NumberFormatOptions,
) {
  const formatter = new Intl.NumberFormat(locale, {
    ...options,
    style: 'currency',
    currency: currencyCode,
  });

  return formatter.format(value);
}
